import React from 'react'
import {graphql} from 'gatsby'
import LegalPageTemplate from '../../components/templates/legal/LegalPageTemplate'

const PrivacyPolicyPage = ({data}) => {
    return <LegalPageTemplate data={data} />
}

export const query = graphql`
  query PrivacyPolicyPageQuery($language: String = "en") {
    markdownRemark(
      frontmatter: {
        type: {eq: "privacy"}
        language: {eq: $language}
      }
    ) {
      html
      frontmatter {
        title
        language
        type
        lastUpdated
      }
    }
  }
`

export default PrivacyPolicyPage
